interface Filters {
    categories?: Array<string>,
    keyword?: string,
    lastActive?: string
}

interface FeaturedSearch {
    title: String,
    filters: Filters
}

interface FeaturedSearchRequest {
    from: number,
    size: number,
    filterBy: Filters
}

interface FeaturedSearchRequests {
    [key: string]: FeaturedSearchRequest;
}

interface FeaturedSearches {
    [key: string]: FeaturedSearch;
}

const featuredCategorySearches: Array<FeaturedSearch> = [
    {title: __('Book and magazine designers'), filters: {categories: ['book-magazine-design']}},
    {title: __('T-shirt designers'), filters: {categories: ['t-shirt-design']}},
    {title: __('PowerPoint template designers'), filters: {categories: ['powerpoint-template-design']}},
    {title: __('3D designers'), filters: {categories: ['3d-design']}},
    {title: __('Brochure designers'), filters: {categories: ['brochure-design']}},
    {title: __('Infographic designers'), filters: {categories: ['infographic-design']}},
    {title: __('Tattoo designers'), filters: {categories: ['tattoo-design']}},
    {title: __('Poster designers'), filters: {categories: ['poster-design']}},
];

const featuredKeywordSearches: Array<FeaturedSearch> = [
    {title: __('Designers with a minimal style'), filters: {keyword: 'minimal'}},
    {title: __('Designers with a retro style'), filters: {keyword: 'retro'}},
    {title: __('Designers with a vintage style'), filters: {keyword: 'vintage'}},
    {title: __('Designers with a modern style'), filters: {keyword: 'modern'}},
    {title: __('Designers with a geometric style'), filters: {keyword: 'geometric'}},
    {title: __('Designers with a watercolor style'), filters: {keyword: 'watercolor'}},
    {title: __('Designers who focus on typography'), filters: {keyword: 'typography'}},
    {title: __('Designers with the animal instinct'), filters: {keyword: 'animal'}},
];

const getRandomSearch = (input: Array<FeaturedSearch>) => {
    const date = new Date();
    return input[date.getDate() % input.length]
}

export const getFeaturedSearches = (): FeaturedSearches => {
    return {
        logo: {title: __('Logo and identity designers'), filters: {categories: ['logo-design']}},
        web: {title: __('Web and app designers'), filters: {categories: ['web-design']},},
        packaging: {title: __('Packaging and label designers'), filters: {categories: ['product-packaging-design']}},
        randomCategory: getRandomSearch(featuredCategorySearches),
        keyword: getRandomSearch(featuredKeywordSearches),
        online: {title: __('Designers online now'), filters: {lastActive: 'ONLINE_NOW',},},
    };
}

export const getFeaturedSearchRequests = (searches: FeaturedSearches) => {
    return Object.keys(searches).reduce<FeaturedSearchRequests>((acc, key) => {
        acc[key] = {
            from: 0,
            size: 3,
            filterBy: {...searches[key].filters},
        };

        return acc;
    }, {});
}



// WEBPACK FOOTER //
// ./src/js/apps/find-designers/components/FeaturedSearchBuilder.ts